import { render, staticRenderFns } from "./email_left_panel.vue?vue&type=template&id=64b37cca&"
import script from "./email_left_panel.vue?vue&type=script&lang=js&"
export * from "./email_left_panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64b37cca')) {
      api.createRecord('64b37cca', component.options)
    } else {
      api.reload('64b37cca', component.options)
    }
    module.hot.accept("./email_left_panel.vue?vue&type=template&id=64b37cca&", function () {
      api.rerender('64b37cca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/mailboxer/email_left_panel.vue"
export default component.exports